import BreadCrumb from '@cohort/merchants/components/BreadCrumb';
import {useCurrentUser} from '@cohort/merchants/hooks/contexts/currentUser';
import {useNavigate} from 'react-router-dom';

const UserPageBreadcrumb = (): JSX.Element => {
  const user = useCurrentUser();
  const navigate = useNavigate();

  return (
    <BreadCrumb
      title={user.email}
      handleBackClick={() => {
        navigate(-1);
      }}
    />
  );
};

export default UserPageBreadcrumb;
